import styled from 'styled-components';

export const CarouselContainer = styled.div<{ reverse: boolean }>`
  && {
    .carousel .control-dots {
      margin: 10px 0;
      padding: 0;
      text-align: center;
      width: auto;
      ${({ reverse }) => (reverse ? 'left:24px;' : 'right:44px;')};
      bottom: 12px;
    }
    .direction {
      direction: initial;
    }

    .carousel .control-dots li:hover {
      opacity: 0.3 !important;
    }

    .carousel .control-dots li {
      background-color: #bdbdbd !important;
    }
    .carousel .slide {
      text-align: start !important;
      border-radius: 8px;
      background-size: cover !important;
      background: #ffffff !important;
    }
  }
`;
